import {MOOD_SAVE_KEY} from './mood-system.js';
import {saveWorldSave} from './world-save.js';

// Records are independently restorable. Best-effort writes are intentionally
// non-atomic: failure of one record must not suppress another useful save.
export function saveJourney({mood,world},storage){
 let moodSaved=false;
 try{(storage??localStorage).setItem(MOOD_SAVE_KEY,JSON.stringify(mood));moodSaved=true;}catch{}
 const worldSaved=saveWorldSave(world,storage);
 return {mood:moodSaved,world:worldSaved};
}

export function installSaveStatus(element){
 const records=new Map();
 return result=>{
  for(const [record,saved] of Object.entries(result))records.set(record,saved);
  const failed=[...records.values()].some(saved=>!saved);
  const message=failed?'Some progress could not be saved. Keep this page open; saving will retry.':'';
  if(element.textContent!==message)element.textContent=message;
 };
}
